import React, { useEffect, useState } from "react";
import { Tooltip } from "@fluentui/react-components";
import { Activity } from "lucide-react";
import ControlledDrawer from "../controls/drawer/ControlledDrawer";
import ResourceInsights from "./ResourceInsights";
import styles from "./resourceInsights.module.scss";

/** The title of the panel; its icon wears the colour of the global performance index, which a tooltip puts in words. */
function DrawerTitle({ verdict }) {
  const icon = (
    <span className={styles.drawerTitleIcon} style={verdict ? { color: verdict.color } : undefined}>
      <Activity size={18} />
    </span>
  );

  return (
    <span className={styles.drawerTitle}>
      {verdict ? (
        <Tooltip content={`Performance Index ${verdict.score} · ${verdict.label}`} relationship="description" positioning="below">
          {icon}
        </Tooltip>
      ) : (
        icon
      )}
      Resource Insights
    </span>
  );
}

/**
 * Resource Insights in the right-hand panel the header's notifications use, opened and closed by its host. The last
 * resource stays drawn while the panel slides closed so its content does not vanish mid-animation. Everything else
 * is what `ResourceInsights` takes.
 *
 * @param open  whether the panel is open
 * @param resource  who it is about; null when nobody is
 * @param onClose  called when the user closes the panel
 */
export default function ResourceInsightsDrawer({ open, onClose, resource, ...insights }) {
  const [lastResource, setLastResource] = useState(null);
  const [verdict, setVerdict] = useState(null);

  useEffect(() => {
    if (resource) setLastResource(resource);
  }, [resource]);

  const shown = resource ?? lastResource;

  return (
    <ControlledDrawer open={open} onClose={onClose} title={<DrawerTitle verdict={verdict} />}>
      {shown && <ResourceInsights key={shown.id} resource={shown} onVerdictChange={setVerdict} {...insights} />}
    </ControlledDrawer>
  );
}
